/**
 * Measures how long opening a conversation takes, from the tap on the Inbox list.
 * The tap time is recorded in markConversationTap(); the thread logs each milestone relative to it,
 * so any delay before the thread even mounts (page transition, rendering) is included.
 */
let tappedAt: number | null = null;

export const markConversationTap = () => {
  tappedAt = performance.now();
};

/** Milliseconds since the last tap, or since `fallback` if the conversation wasn't opened by a tap */
export const msSinceOpen = (fallback: number): string =>
  (performance.now() - (tappedAt ?? fallback)).toFixed(0);
